const isDev = false; //process.env.NODE_ENV === "development";

export const API_BASE_URL = isDev
  ? "http://localhost:8000/api"
  : "https://www.fdmedia.us/api";

export const PREVIEW_BASE_URL = isDev
  ? "http://localhost:8000/preview/"
  : "https://www.fdmedia.us/preview/";
